import PrimeiraConsultaProgramadaIcon from '@/components/icons/IndicadoresEsb/Ampliados/Prevencao.vue'

export default {
  value: 'b1',
  label: 'Primeira consulta',
  iconType: 'component',
  iconComponent: PrimeiraConsultaProgramadaIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: ({ perfilEsfOuEmulti }) =>
      perfilEsfOuEmulti
        ? 'Encaminhar para realizar e registrar a 1ª consulta odontológica, com plano de tratamento no odontograma (em atraso).'
        : 'Realizar e registrar a 1ª consulta odontológica, com plano de tratamento no odontograma (em atraso).',
  },
}
